import { Oewa } from '@components/atoms/Oewa/Oewa';
import { ArticleHeroTeaser } from '@components/organisms/ArticleHeroTeaser/ArticleHeroTeaser';
import { Ressort } from '@components/organisms/PageContents/RessortPage';
import { extractSsrState } from '@lib/graphql/helpers/extractSsrState';
import { createUrqlClient } from '@lib/graphql/urql';
import { useTagManager } from '@lib/hooks/useTagManager';
import { GetAllArticlesPaginatedDocument, GetAllRessortsDocument } from '@src/lib/graphql/generated';
import { getCookie } from '@utils/cookies';
import { AditionInitialization } from '@vgn-medien-holding/vgn-fe-components';
import { RESSORT_ARTICLES_PER_LOAD } from 'tvm-config';

// Magazin
const ad_settings_Magazin = {
  cad1: {
    id: 5256654,
    name: 'TVM_Magazin_MedRec_Cad',
    yieldLab: [],
    breakpoints: [3, 4, 5, 6],
  },
  mobile_top: {
    id: 5256632,
    name: 'TVM_Mobile_Gewinnspiele_HPA', //achtung es gibt keine HPA für magazin
    yieldLab: [],
    breakpoints: [0, 1, 2, 3],
  },
  mobile_middle1: {
    id: 5256654,
    name: 'TVM_Magazin_MedRec_Cad', //achtung es gibt keine mobile MedRec für magazin, hab einfach die desktop genommen
    yieldLab: [],
    breakpoints: [0, 1, 2, 3],
  },
};

export function MagazineIndex({ data }) {
  useTagManager({
    event: 'metadata',
    loginStatus: 'nicht eingeloggt',
    seitentyp: 'Magazin',
    titel: 'Magazin',
    aktualisierungsdatum: data?.updated_at,
    erstellungsdatum: data?.created_at,
    oewaSeitenkontingent: 'Redcont',
    oewaSubkontingent: 'Homepage',
    oewaProfilingkontingent: 'Homepage',
    cookieAlert: getCookie('OptanonConsent'),
  });

  return (
    <>
      <Oewa pageKey={'Redcont'} categoryKey={'Homepage'} profileKey={'Homepage'} />
      <AditionInitialization data={{ ad_settings: ad_settings_Magazin }} />
      <div className="grid gap-y-12 px-4 py-5 lg:px-16">
        <ArticleHeroTeaser articles={data?.articles?.data} />
      </div>
      <Ressort data={{ ...data, ad_settings: ad_settings_Magazin }} />
    </>
  );
}

export const magazineSsrLogic = async () => {
  const { ssrQuery, ssrCache } = createUrqlClient();
  const { data: articlesData } = await ssrQuery({
    query: GetAllArticlesPaginatedDocument,
    variables: {
      portal: 'tvmedia',
      first: 4,
      page: 1,
      orderBy: 'updated_at',
      orderDirection: 'DESC',
    },
  });
  const articles = articlesData?.articlesPaginated;

  const { data: ressortsData } = await ssrQuery({
    query: GetAllRessortsDocument,
    variables: { portal: 'tvmedia' },
  });
  const ressorts = ressortsData?.ressorts;

  await ssrQuery({
    query: GetAllArticlesPaginatedDocument,
    variables: {
      portal: 'tvmedia',
      first: RESSORT_ARTICLES_PER_LOAD,
      page: 1,
    },
  });

  const data = {
    articles,
    ressorts,
  };

  return {
    revalidate: 60 * 60 * 24 * 2, // 2 days
    props: {
      data,
      slug: 'magazin',
      urqlState: extractSsrState(ssrCache),
    },
  };
};
